//App
import { AgencyApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const agencyApi: AgencyApiType = {
  getAgency: (payload) => apiClient.get(endPoints.agency.getAgency(payload)),
  searchAgency: (payload) => apiClient.post(endPoints.agency.searchAgency(), payload),
  saveAgency: (payload) => apiClient.post(endPoints.agency.saveAgency(), payload),
  activateAgency: (value) => apiClient.post(endPoints.agency.activateAgency(value)),
  deactivateAgency: (value) => apiClient.post(endPoints.agency.deactivateAgency(value)),
};

export default agencyApi;